import { reactQueryPatch } from "@circle-react/helpers/backendRequestHelpers";
import { eventAttendees } from "@circle-react/helpers/urlHelpers/internalApi/eventAttendees";
import type { Event } from "@circle-react/types/Event";

interface DemoteCohostOptions {
  attendeeId: string | number;
  event: Event;
}

export const demoteCohost = <T = unknown>({
  event,
  attendeeId,
}: DemoteCohostOptions) =>
  reactQueryPatch<T, object>(
    eventAttendees.demoteCohost({
      slug: event.slug,
      spaceId: event.space_id,
      attendeeId,
    }),
  );
